import Vue from 'vue'
import { registerLicense } from '@syncfusion/ej2-base'
import { GridPlugin } from '@syncfusion/ej2-vue-grids'
import { GanttPlugin } from '@syncfusion/ej2-vue-gantt'

Vue.use(GridPlugin)
Vue.use(GanttPlugin)

registerLicense('ORg4AjUWIQA/Gnt2U1hhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5VdENjWX9XcnRcQmhY')
